import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LastWillStateStep(): ReactElement {
  const dispatch = useDispatch();
  const {
    willPurchasedInSameStateAsResidence: willPurchasedInSameStateAsResidence,
  } = useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('what_state_is_will_in');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header=" Is the state where you got your will the same as the state you're living
          in now?"
        subHeader="Each U.S. state has different laws and requirements for wills."
      />
      <Formik
        initialValues={{ willPurchasedInSameStateAsResidence }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema(
          'willPurchasedInSameStateAsResidence'
        )}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator
            name="willPurchasedInSameStateAsResidence"
            showNotSure={true}
          />

          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { LastWillStateStep };
